import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'sb-react-intl'
import cx from 'classnames'

import messages from './messages'
import s from './OutOfStockText.scss'


const OutOfStockText = ({ className }) => (
  <FormattedMessage
    className={cx(s.text, className)}
    tag="div"
    {...messages.text}
  />
)

OutOfStockText.propTypes = {
  className: PropTypes.string,
}


export default OutOfStockText
